import { Paper, Text, Group, createStyles, Box, LoadingOverlay } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useDasboardApi from '../../hooks/useDashboardApi';
import DetailMenu from './card-components/DetailMenu';
import PercentageComparison from './charts/PercentageComparison';
import FilterSelector from './selectors/FilterSelector';
import Papa from 'papaparse';
import { saveAs } from 'file-saver';

// Custom styles
const useStyles = createStyles((theme) => ({
	container: {
		padding: '20px 0 10px'
	},
	text: {
		fontSize: 36,
		lineHeight: '42px',
		fontWeight: 400,
		color: theme.colorScheme === 'light' ? '#4A4A4A' : '#C1C2C5',
	},
	cardTitle: {
		fontWeight: 600,
		fontSize: 16,
		lineHeight: '20px',
		color: theme.colorScheme === 'light' ? '#4A4A4A' : '#C1C2C5',
	}
}));

export default function RegisteredUsers() {

	// State and hooks
	const { classes } = useStyles();
	const { getActiveUsers } = useDasboardApi();
	const { activeUsers, userTypes } = useSelector(state => state.dashboardData);
	const [filters, setFilters] = useState([]);
	const [visible, setVisible] = useState(false);

	// On load
	useEffect(() => {
		async function fetchData() {
			await getActiveUsers(filters);
		}
		fetchData();
		// eslint-disable-next-line
	}, []);

	// Filter changes
	useEffect(() => {

		// Only if initial data has loaded
		if (activeUsers !== null) reload();

		// eslint-disable-next-line
	}, [filters]);

	// Reload with new values
	const reload = async () => {

		// Set loader
		setVisible(true);

		// Get information
		await getActiveUsers(filters);

		// Remove loader
		setVisible(false);

	}

	// Convert and download as CSV file
	const convertToCSV = () => {

		// Copy and stringify
		const parsedData = [{
			activos: activeUsers[0]?.actives || 0,
			inactivos: activeUsers[0]?.inactives || 0,
		}];

		// Parse and convert to CSV
		const csv = Papa.unparse(parsedData, { header: true });

		// Generate file
		const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

		// Save file
		saveAs(blob, 'usuarios-registrados.csv');

	};

	return (
		<Paper
			withBorder
			p={12}
			style={{ position: 'relative' }}
			radius={18}
		>
			{/* Loading Overlay */}
			<LoadingOverlay
				visible={visible}
				overlayBlur={1}
				radius={18}
			/>
			{/* Top */}
			<Group
				position="apart"
				noWrap
			>
				{/* Title */}
				<Text className={classes.cardTitle}>
					Registrados
				</Text>
				{/* Menu */}
				<DetailMenu onClick={() => convertToCSV()} />
			</Group>
			{/* Time & Filter */}
			<Group
				position="apart"
				mt={8}
				noWrap
				align="center"
			>
				{/* Empty */}
				&nbsp;
				{/* Filter */}
				<FilterSelector
					label="Usuarios"
					options={userTypes}
					selected={[filters, setFilters]}
				/>
			</Group>
			{/* Content */}
			<Box className={classes.container}>
				{/* Container */}
				<Group position="apart">
					{/* Number */}
					<Text className={classes.text}>
						{activeUsers ? new Intl.NumberFormat('es-AR', { notation: 'compact' }).format(activeUsers[0].actives + activeUsers[0].inactives).replace(/\s(?=K|k|M|B|T)/, '') : 0}
					</Text>
					{/* Chart */}
					{activeUsers ?
						<PercentageComparison
							leftData={activeUsers[0]?.actives}
							rightData={activeUsers[0]?.inactives}
							leftText="activos"
							rightText="inactivos"
						/>
					: null}
				</Group>
			</Box>
		</Paper>
	);

}
